import React, { useState, useEffect, useContext, useMemo } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import Header from '../../../layout/Header/Header';
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
  Alert
} from 'reactstrap';
import SweetAlert from 'sweetalert2-react';
import Swal from 'sweetalert2';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import ExportJsonExcel from 'js-export-excel';
import { encode } from 'base64-arraybuffer';
import axios from 'axios';
import { TableHeader, Pagination, Search } from '../../../DataTable';
import useFullPageLoader from '../../../hooks/useFullPageLoader';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { v4 as uuidv4 } from 'uuid';
import EtaUpdate from '../../EtaUpdate';
import Baja from '../../Baja';
import * as XLSX from "xlsx";
// import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
// import L from 'leaflet';

// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

function ListadoContenedores() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_ARTICULOS_CONTENEDOR = process.env.REACT_APP_URL_ARTICULOS_CONTENEDOR;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_GASTOS_CONTENEDOR = process.env.REACT_APP_URL_GASTOS_CONTENEDOR;
  const URL_CARGOS_CONTENEDOR = process.env.REACT_APP_URL_CARGOS_CONTENEDOR;
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_TERMINALES = process.env.REACT_APP_URL_TERMINALES;
  const URL_PROGRAMAS = process.env.REACT_APP_URL_PROGRAMAS;
  const URL_PATENTES = process.env.REACT_APP_URL_PATENTES;
  const URL_UPMEDIA_PACKING = process.env.REACT_APP_URL_UPMEDIA_PACKING;
  const URL_UPMEDIA_BL = process.env.REACT_APP_URL_UPMEDIA_BL;
  const URL_UPMEDIA_INVOICE = process.env.REACT_APP_URL_UPMEDIA_INVOICE;
  const URL_UPMEDIA_VALIDACION = process.env.REACT_APP_URL_UPMEDIA_VALIDACION;
  const URL_UPMEDIA_GARANTIA = process.env.REACT_APP_URL_UPMEDIA_GARANTIA;
  const URL_UPMEDIA_TRANSPORTE = process.env.REACT_APP_URL_UPMEDIA_TRANSPORTE;
  const URL_DELMEDIA = process.env.REACT_APP_URL_DELMEDIA;

  const [t, i18n] = useTranslation('global');
  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 365);

  let comp30 = new Date();
  comp30.setDate(comp30.getDate() - 30);

  let endDate = moment(hoy).format('YYYY-MM-DD');
  let startDate = moment(inicio).format('YYYY-MM-DD');

  const [articulos, setArticulos] = useState([]);

  const [programas, setProgramas] = useState([]);
  const [patentes, setPatentes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [terminales, setTerminales] = useState([]);
  const [selectedNaviera, setSelectedNaviera] = useState('');
  const [selectedTerminal, setSelectedTerminal] = useState('');
  const [selectedPrograma, setSelectedPrograma] = useState('');
  const [selectedPatente, setSelectedPatente] = useState('');
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState('');
  const [selectedAgente, setSelectedAgente] = useState('');
  const [selectedForwarder, setSelectedForwarder] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedExpediente, setSelectedExpediente] = useState('');
  const [selectedEIR, setSelectedEIR] = useState('');
  const [selectedPuerto, setSelectedPuerto] = useState('');
  const [selectedModalidad, setSelectedModalidad] = useState('');
  const [selectedAsegurado, setSelectedAsegurado] = useState('');
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedMayorQue, setSelectedMayorQue] = useState(0);
  const [selectedMenorQue, setSelectedMenorQue] = useState(0);
  const [selectedDuplicado, setSelectedDuplicado] = useState("");

  const [selectedPendiente, setSelectedPendiente] = useState('No');
  const [selectedActivo, setSelectedActivo] = useState('Si');

  const [fecha, setFecha] = useState('');
  const [numeroBl, setNumeroBl] = useState('');
  const [referencia, setReferencia] = useState('');
  const [puerto, setPuerto] = useState('');
  const [puertoOrigen, setPuertoOrigen] = useState('');
  const [direccionEntrega, setDireccionEntrega] = useState('');
  const [observaciones, setObservaciones] = useState('NA');
  const [observacionesInternas, setObservacionesInternas] = useState('NA');
  const [totalGeneral, setTotalGeneral] = useState('');
  const [totalCantidad, setTotalCantidad] = useState('');
  const [numeroContenedor, setNumeroContenedor] = useState('');
  const [articulo, setArticulo] = useState('');
  const [apoyo, setApoyo] = useState('');
  const [importador, setImportador] = useState('');
  const [valorFactura, setValorFactura] = useState('');
  const [numeroInternoEdit, setNumeroInternoEdit] = useState('');
  const [etaReal, setEtaReal] = useState('');
  const [rastreo, setRastreo] = useState('No');
  const [pesoTotal, setPesoTotal] = useState(0);

  const [idEdit, setIdEdit] = useState('');
  const [selectedNavieraEdit, setSelectedNavieraEdit] = useState('');
  const [selectedClienteEdit, setSelectedClienteEdit] = useState('');
  const [selectedAgenteEdit, setSelectedAgenteEdit] = useState('');
  const [selectedForwarderEdit, setSelectedForwarderEdit] = useState('');

  const [coordenadasMapa, setCoordenadasMapa] = useState([]);
  const [originCoords, setOriginCoords] = useState([]);
  const [destinationCoords, setDestinationCoords] = useState([]);
  const [vesselCoords, setVesselCoords] = useState([]);
  const [diasLlegada, setDiasLlegada] = useState(0);

  const [modalMapa, setModalMapa] = useState(false);
  const toggleMapa = () => setModalMapa(!modalMapa);

  const [numeroInterno, setnumeroInterno] = useState('');
  const [contenedor, setContenedor] = useState('');
  // const [fechaETAEstimada, setFechaETAEstimada] = useState("");
  const [fechaETAReal, setETAReal] = useState('');

  const [articulosContenedor, setArticulosContenedor] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [totalGeneral_edit, setTotalGeneralEdit] = useState(0);
  const [totalCantidad_edit, setTotalCantidadEdit] = useState(0);


  const [modalSubirFotoPacking, setModalSubirFotoPacking] = useState(false);
  const toggleSubirFotoPacking = () => setModalSubirFotoPacking(!modalSubirFotoPacking);
  const [modalFotoPacking, setModalFotoPacking] = useState(false);
  const toggleFotoPacking = () => setModalFotoPacking(!modalFotoPacking);

  const [modalSubirFotoBL, setModalSubirFotoBL] = useState(false);
  const toggleSubirFotoBL = () => setModalSubirFotoBL(!modalSubirFotoBL);
  const [modalFotoBL, setModalFotoBL] = useState(false);
  const toggleFotoBL = () => setModalFotoBL(!modalFotoBL);

  const [modalSubirFotoValidacion, setModalSubirFotoValidacion] = useState(false);
  const toggleSubirFotoValidacion = () => setModalSubirFotoValidacion(!modalSubirFotoValidacion);
  const [modalFotoValidacion, setModalFotoValidacion] = useState(false);
  const toggleFotoValidacion = () => setModalFotoValidacion(!modalFotoValidacion);

  const [modalSubirFotoInvoice, setModalSubirFotoInvoice] = useState(false);
  const toggleSubirFotoInvoice = () => setModalSubirFotoInvoice(!modalSubirFotoInvoice);
  const [modalFotoInvoice, setModalFotoInvoice] = useState(false);
  const toggleFotoInvoice = () => setModalFotoInvoice(!modalFotoInvoice);

  const [modalSubirFotoGarantia, setModalSubirFotoGarantia] = useState(false);
  const toggleSubirFotoGarantia = () => setModalSubirFotoGarantia(!modalSubirFotoGarantia);
  const [modalFotoGarantia, setModalFotoGarantia] = useState(false);
  const toggleFotoGarantia = () => setModalFotoGarantia(!modalFotoGarantia);

  const [modalSubirFotoTransporte, setModalSubirFotoTransporte] = useState(false);
  const toggleSubirFotoTransporte = () => setModalSubirFotoTransporte(!modalSubirFotoTransporte);
  const [modalFotoTransporte, setModalFotoTransporte] = useState(false);
  const toggleFotoTransporte = () => setModalFotoTransporte(!modalFotoTransporte);

  const [packing, setPacking] = useState('');
  const [blArchivo, setBlArchivo] = useState('');
  const [validacion, setValidacion] = useState('');
  const [invoice, setInvoice] = useState('');
  const [garantia, setGarantia] = useState('');
  const [transporte, setTransporte] = useState('');


  const [modalFotos, setModalFotos] = useState(false);
  const toggleFotos = () => setModalFotos(!modalFotos);


  const [photo, setPhoto] = useState([]);
  const [idContenedor, setIdContenedor] = useState();
  const [file, setFile] = useState([]);


    const [modalArchivo, setModalArchivo] = useState(false);
    const toggleArchivo = () => setModalArchivo(!modalArchivo);
      const [inputFieldsContenedores, setInputFieldsContenedores] = useState([
        {
          id: uuidv4(),
          cliente: "",
          idCliente: "",
          referencia: "",
          referenciaCliente: "",
          contenedor: "",
          eta: "",
          apoyo: "",
          importador: "",
          articulo: "",
          valorFactura: 0,
          pedimento: "",
          modalidad: "",
          puerto: "",
          direccionEntrega: "",
        },
      ]);
  const [totalContenedores, setTotalContenedores] = useState(0);

  const [validaBoton, setValidaBoton] = useState(true);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: '',
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState('');

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalCambiarCliente, setModalCambiarCliente] = useState(false);
  const toggleCambiarCliente = () => setModalCambiarCliente(!modalCambiarCliente);
  const [idCambiarCliente, setIdCambiarCliente] = useState('');
  const [contenedorCambiarCliente, setContenedorCambiarCliente] = useState('');
  const [clienteActualCambiar, setClienteActualCambiar] = useState('');
  const [clienteNuevo, setClienteNuevo] = useState('');

  const [modalETA, setModalETA] = useState(false);
  const toggleETA = () => setModalETA(!modalETA);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalStatus, setModalStatus] = useState(false);
  const toggleStatus = () => setModalStatus(!modalStatus);
  const [id, setid] = useState('');
  const [bl, setbl] = useState('');
  const [pl, setpl] = useState('');
  const [pedimento, setPedimento] = useState('');
  const [factura, setfactura] = useState('');
  const [modalidad, setModalidad] = useState('');
  const [idClientes, setIdClientes] = useState('');
  const [totalCargosEdit, setTotalCargosEdit] = useState('');
  const [totalGastosEdit, setTotalGastosEdit] = useState('');
  const [asegurado, setAsegurado] = useState('');
  const [documentos, setdocumentos] = useState('');
  const [telex, settelex] = useState('');
  const [toquePiso, settoquePiso] = useState('');
  const [revalidacion, setrevalidacion] = useState('');
  const [fichaTecnica, setfichaTecnica] = useState('');
  const [pagoPedimento, setpagoPedimento] = useState('');
  const [modulacion, setmodulacion] = useState('');
  const [retornoVacio, setretornoVacio] = useState('');
  const [salidaPuerto, setsalidaPuerto] = useState('');
  const [salidaRuta, setsalidaRuta] = useState('');
  const [entregaCliente, setentregaCliente] = useState('');
  const [maniobras, setmaniobras] = useState('');
  const [status, setStatus] = useState('');
  const [EIR, setEIR] = useState('');
  const [expediente, setExpediente] = useState('');
  const [fechaEntradaPuerto, setfechaEntradaPuerto] = useState('');
  const [fechaDocumentos, setfechaDocumentos] = useState('');
  const [fechaTelex, setfechaTelex] = useState('');
  const [fechaToquePiso, setfechaToquePiso] = useState('');
  const [fechaRevalidacion, setfechaRevalidacion] = useState('');
  const [fechaFichaTecnica, setfechaFichaTecnica] = useState('');
  const [fechaPagoPedimento, setfechaPagoPedimento] = useState('');
  const [fechaModulacion, setfechaModulacion] = useState('');
  const [fechaRetornoVacio, setfechaRetornoVacio] = useState('');
  const [fechaSalidaPuerto, setfechaSalidaPuerto] = useState('');
  const [fechaSalidaRuta, setfechaSalidaRuta] = useState('');
  const [fechaEntregaCliente, setfechaEntregaCliente] = useState('');
  const [fechaManiobras, setfechaManiobras] = useState('');
  const [fechaFactura, setfechaFactura] = useState('');
  const [fechaBl, setfechaBl] = useState('');
  const [fechaPl, setfechaPl] = useState('');

  const [modalGastos, setModalGastos] = useState(false);
  const toggleGastos = () => setModalGastos(!modalGastos);
  const [fechaGasto, setFechaGasto] = useState(endDate);
  const [totalUSD, setTotalUSD] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState('NA');
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState('');
  const [selectedProveedor, setSelectedProveedor] = useState('');
  const [selectedContenedor, setSelectedContenedor] = useState('');
  const [selectedClienteGasto, setSelectedClienteGasto] = useState('');
  const [moneda, setMoneda] = useState('MXN');

  const [modalCargos, setModalCargos] = useState(false);
  const toggleCargos = () => setModalCargos(!modalCargos);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState({ field: '', order: '' });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(
        `${URL_CONTENEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then((response) => {
        let allContenedores = response.data;
        // Array para pagination
        let arrayTabla = allContenedores
          .sort((a, b) => (a.etaReal > b.etaReal ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idContenedor,
              activo: a.is_active,
              fecha: a.fecha,
              observaciones: a.observaciones,
              observacionesInternas: a.observacionesInternas,
              totalGeneral: a.totalGeneral,
              navieras: a.navieras[0].name,
              idNavieras: a.navieras[0]._id,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              agentes: a.agentes[0].name,
              idAgentes: a.agentes[0]._id,
              terminales: a.terminales[0].name,
              idTerminales: a.terminales[0]._id,
              programas: a.programas[0].name,
              idProgramas: a.programas[0]._id,
              patentes: a.patentes[0].name,
              idPatentes: a.patentes[0]._id,
              forwarders: a.forwarders[0].name,
              idForwarders: a.forwarders[0]._id,
              totalCantidad: a.totalCantidad,
              numeroInterno: a.numeroInterno,
              contenedor: a.contenedor,
              // etaEstimada: a.etaEstimada,
              etaReal: a.etaReal,
              bl: a.bl,
              pl: a.pl,
              invoice: a.invoice,
              validacion: a.validacion,
              garantia: a.garantia,
              packing: a.packing,
              transporte: a.transporte,
              totalGastos: a.totalGastos,
              totalCargos: a.totalCargos,
              puerto: a.puerto,
              puertoOrigen: a.puertoOrigen,
              numeroBl: a.numeroBl,
              referencia: a.referencia,
              direccionEntrega: a.direccionEntrega,

              pedimento: a.pedimento,
              modalidad: a.modalidad,

              asegurado: a.asegurado,

              factura: a.factura,
              documentos: a.documentos,
              telex: a.telex,
              toquePiso: a.toquePiso,
              revalidacion: a.revalidacion,
              fichaTecnica: a.fichaTecnica,
              pagoPedimento: a.pagoPedimento,
              modulacion: a.modulacion,
              retornoVacio: a.retornoVacio,
              salidaPuerto: a.salidaPuerto,
              salidaRuta: a.salidaRuta,
              entregaCliente: a.entregaCliente,
              maniobras: a.maniobras,
              status: a.status,
              EIR: a.EIR,
              expediente: a.expediente,
              // status: a.status == "Entregado" ? a.status + " " + a.fechaEntregaCliente : a.status,
              fechaEntradaPuerto: a.fechaEntradaPuerto,
              fechaDocumentos: a.fechaDocumentos,
              fechaTelex: a.fechaTelex,
              fechaToquePiso: a.fechaToquePiso,
              fechaRevalidacion: a.fechaRevalidacion,
              fechaFichaTecnica: a.fechaFichaTecnica,
              fechaPagoPedimento: a.fechaPagoPedimento,
              fechaModulacion: a.fechaModulacion,
              fechaRetornoVacio: a.fechaRetornoVacio,
              fechaSalidaPuerto: a.fechaSalidaPuerto,
              fechaSalidaRuta: a.fechaSalidaRuta,
              fechaEntregaCliente: a.fechaEntregaCliente,
              fechaManiobras: a.fechaManiobras,
              fechaFactura: a.fechaFactura,
              fechaBl: a.fechaBl,
              fechaPl: a.fechaPl,

              rastreo:a.rastreo,
              mapa:a.mapa,
              fromCountry: a.fromCountry,
              polOrigen: a.polOrigen,
              loadingDate: a.loadingDate,
              departureDate: a.departureDate,
              toCountry: a.toCountry,
              podDestino: a.podDestino,
              arrivalDate: a.arrivalDate,
              dischargeDate: a.dischargeDate,
              vessel: a.vessel,
              vesselIMO: a.vesselIMO,
              vesselLatitude: a.vesselLatitude,
              vesselLongitude: a.vesselLongitude,
              vesselVoyage: a.vesselVoyage,
              polLatitude: a.polLatitude,
              polLongitude: a.polLongitude,
              podLatitude: a.podLatitude,
              podLongitude: a.podLongitude,
              vesselLatitude: a.vesselLatitude,
              vesselLongitude: a.vesselLongitude,
              pesoTotal: a.pesoTotal,

              importador: a.importador,
              apoyo: a.apoyo,
              articulo: a.articulo,
              valorFactura: a.valorFactura,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        // Buscar referencias duplicadas con is_active === "Si"
const referenciasActivas = arrayTabla
  .filter((a) => a.activo === "Si" && a.referencia)
  .map((a) => a.referencia);

const duplicadas = referenciasActivas.filter((ref, index, self) => self.indexOf(ref) !== index);

// Marcar los duplicados
let dataFinal = arrayTabla.map((item) => {
  if (
    item.activo === "Si" &&
    item.referencia &&
    duplicadas.includes(item.referencia)
  ) {
    return { ...item, duplicado: "Si" };
  } else {
    return { ...item, duplicado: "No" };
  }
});


        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_TERMINALES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allTerminales = response.data;
        setTerminales(allTerminales);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_PROVEEDORES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_PROGRAMAS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allProgramas = res.data;
        setProgramas(allProgramas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_PATENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allPatentes = res.data;
        setPatentes(allPatentes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_GASTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedMayorQue == 0 || selectedMayorQue <= a.numero) &&
        (selectedMenorQue == 0 || selectedMenorQue >= a.numero) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedEIR == 0 || selectedEIR == a.EIR) &&
        (selectedExpediente == 0 || selectedExpediente == a.expediente) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.fecha,
          a.clientes,
          a.referencia,
          a.numeroInterno,
          a.contenedor,
          a.etaReal,
          a.importador,
          a.apoyo,
          a.articulo,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(a.valorFactura),
          a.pedimento,
          a.modalidad,
          a.puerto,
          a.direccionEntrega,
          a.status,
          a.EIR,
          a.expediente,
          a.fechaEntregaCliente
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF('landscape');
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 120, 15, 65, 28);
    doc.text(`Listado Contenedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          'Fecha',
          'Cliente',
          'Referencia',
          'Ref Cliente',
          'Contenedor',
          'ETA Real',
          'Importador',
          'Apoyo',
          'Articulo',
          'Valor Factura',
          'Pedimento',
          'Modalidad',
          'Puerto',
          'Direccion Entrega',
          'Status',
          'EIR',
          'Expediente',
          'Ent. Cliente',
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Contenedores.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedMayorQue == 0 || selectedMayorQue <= a.numero) &&
        (selectedMenorQue == 0 || selectedMenorQue >= a.numero) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedEIR == 0 || selectedEIR == a.EIR) &&
        (selectedExpediente == 0 || selectedExpediente == a.expediente) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return {
          Fecha: a.fecha,
          Cliente: a.clientes,
          Referencia: a.referencia,
          ReferenciaCliente: a.numeroInterno,
          Contenedor: a.contenedor,
          ETA: a.etaReal,
          Importador: a.importador,
          Apoyo: a.apoyo,
          Articulo: a.articulo,
          ValorFactura: new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(a.valorFactura),
          Pedimento: a.pedimento,
          Modalidad: a.modalidad,
          Puerto: a.puerto,
          DireccionEntrega: a.direccionEntrega,
          Status: a.status,
          EIR: a.EIR,
          Expediente: a.expediente,
          EntregaCliente: a.fechaEntregaCliente
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = 'ListadoContenedores';

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: 'ListadoContenedores',
        sheetFilter: [
          'Fecha',
          'Cliente',
          'Referencia',
          'ReferenciaCliente',
          'Contenedor',
          'ETA',
          'Importador',
          'Apoyo',
          'Articulo',
          'ValorFactura',
          'Pedimento',
          'Modalidad',
          'Puerto',
          'DireccionEntrega',
          'Status',
          'EIR',
          'Expediente',
          'EntregaCliente',
        ],
        sheetHeader: [
          'Fecha',
          'Cliente',
          'Referencia',
          'ReferenciaCliente',
          'Contenedor',
          'ETA',
          'Importador',
          'Apoyo',
          'Articulo',
          'ValorFactura',
          'Pedimento',
          'Modalidad',
          'Puerto',
          'DireccionEntrega',
          'Status',
          'EIR',
          'Expediente',
          'EntregaCliente',
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedMayorQue == 0 || selectedMayorQue <= a.numero) &&
        (selectedMenorQue == 0 || selectedMenorQue >= a.numero) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedEIR == 0 || selectedEIR == a.EIR) &&
        (selectedExpediente == 0 || selectedExpediente == a.expediente) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.etaReal,
          a.numeroInterno,
          a.referencia,
          a.contenedor,
          a.navieras,
          a.clientes,
          a.agentes,
          a.forwarders,
          a.puerto,
          a.terminal,
          a.modalidad,
          a.fechaSalidaPuerto,
          a.fechaSalidaRuta,
          a.status,
          a.EIR,
          a.expediente,
          a.observaciones,
          a.programa,
          a.totalCantidad,
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2,
          }).format(a.totalGeneral),
          a.direccionEntrega,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF('landscape');
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 120, 15, 65, 28);
    doc.text(`Listado Contenedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          'Numero',
          'Fecha',
          'ETA',
          'No. Interno',
          'Contenedor',
          'Naviera',
          'Cliente',
          'Agente Aduanal',
          'Forwarder',
          'Puerto',
          'Terminal',
          'Modalidad',
          'Salida Puerto',
          'Salida Ruta',
          'Status',
          'EIR',
          'Expediente',
          'Observaciones',
          'Programa',
          'Cantidad',
          'Total',
          'Direccion Entrega',
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output('arraybuffer');
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: 'Listado Contenedores',
          email: mailTo,
          fileName: 'ListadoContenedores.pdf',
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Contenedores.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire('Good job!', 'Enviado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    idEdit,
    fecha,
    numeroInterno,
    referencia,
    contenedor,
    etaReal,
    importador,
    apoyo,
    articulo,
    valorFactura,
    pedimento,
    modalidad,
    puerto,
    direccionEntrega,
    idClientes,
    totalCargos,
    totalGastos
  ) {
    setIdEdit(idEdit);
    setFecha(fecha);
    setNumeroInternoEdit(numeroInterno);
    setReferencia(referencia);
    setContenedor(contenedor);
    setETAReal(etaReal);
    setImportador(importador);
    setApoyo(apoyo);
    setArticulo(articulo);
    setValorFactura(valorFactura);
    setPedimento(pedimento);
    setModalidad(modalidad);
    setPuerto(puerto);
    setDireccionEntrega(direccionEntrega);
    setIdClientes(idClientes);
    setTotalCargosEdit(totalCargos);
    setTotalGastosEdit(totalGastos);
    toggleEdit();
  }

  async function PDFOC(
    fecha,
    idNavieras,
    navieras,
    clientes,
    agentes,
    totalCantidad,
    totalGeneral,
    observaciones,
    numero,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].name,
              descripcion: a.descripcion,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let cant = inputFields.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidad(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);

        const data = dataFinal.map((a) => {
          return [
            a.articulos,
            a.descripcion,
            new Intl.NumberFormat('en-US').format(a.cantidad),
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(a.precio),
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF('landscape');
        var img = new Image();
        img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
        doc.addImage(img, 'png', 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
        doc.addImage(img2, 'png', 120, 15, 45, 15);
        doc.text(`Contenedor # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Naviera ${navieras}`, 20, 30);
        doc.text(
          `Piezas ${new Intl.NumberFormat('en-US').format(totalCantidad)}`,
          20,
          40
        );
        doc.autoTable({
          head: [['Articulo', 'Descripcion', 'Cantidad', 'Precio', 'Total']],
          body: dataPDFLimpia,
          startY: 45,
          foot: [
            [
              '',
              '',
              '',
              'Total',
              new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
              }).format(totalGeneral),
            ],
          ],
          showFoot: 'lastPage',
        });
        doc.save(`Contenedor-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function editContenedores(event) {
    event.preventDefault();
    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;

    axios
      .patch(
        URL_CONTENEDORES_EDIT,
        {
          fecha,
          numeroInterno: numeroInternoEdit,
          referencia,
          contenedor,
          etaReal: fechaETAReal,
          importador,
          apoyo,
          articulo,
          valorFactura,
          pedimento,
          modalidad,
          puerto,
          direccionEntrega,
          // El cliente NO se cambia aquí: usa el botón "Cambiar Cliente"
          // (endpoint contenedoresCambiarCliente) para arrastrar la cascada.
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Editar Contenedor',
            detalle: `${numeroContenedor} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        ).then(() => {
          toggleEdit();
          Swal.fire('Good job!', 'Actualizado con exito', 'success');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });


      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaCambiarCliente(idContenedor, numeroContenedorRow, clienteActual) {
    setIdCambiarCliente(idContenedor);
    setContenedorCambiarCliente(numeroContenedorRow);
    setClienteActualCambiar(clienteActual);
    setClienteNuevo('');
    toggleCambiarCliente();
  }

  function cambiarClienteContenedor(event) {
    event.preventDefault();
    if (!clienteNuevo) {
      Swal.fire('Atención', 'Selecciona el cliente destino', 'warning');
      return;
    }
    const URL_CAMBIAR_CLIENTE = `${process.env.REACT_APP_URL_CONTENEDORES}CambiarCliente/${idCambiarCliente}`;
    axios
      .patch(
        URL_CAMBIAR_CLIENTE,
        { clienteNuevo },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Cambiar Cliente Contenedor',
            detalle: `${contenedorCambiarCliente} -> ${clienteNuevo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        ).then(() => {
          toggleCambiarCliente();
          Swal.fire('Good job!', 'Cliente cambiado con exito', 'success');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response?.data?.message || error.message}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: `${t('Fecha')}`, field: 'fecha', sortable: true },
    { name: `${t('Cliente')}`, field: 'clientes', sortable: true },
    { name: `${t('Referencia')}`, field: 'referencia', sortable: true },
    { name: `${t('Referencia Cliente')}`, field: 'numeroInterno', sortable: true },
    { name: `${t('Contenedor')}`, field: 'contenedor', sortable: true },
    { name: `${t('ETA')}`, field: 'etaReal', sortable: true },
    { name: `${t('Importador')}`, field: 'importador', sortable: true },
    { name: `${t('Apoyo')}`, field: 'apoyo', sortable: true },
    { name: `${t('Articulo')}`, field: 'articulo', sortable: true },
    { name: `${t('Valor Factura')}`, field: 'valorFactura', sortable: true },
    { name: `${t('Pedimento')}`, field: 'pedimento', sortable: true },
    { name: `${t('Modalidad')}`, field: 'modalidad', sortable: true },
    { name: `${t('Puerto')}`, field: 'puerto', sortable: true },
    { name: `${t('Dir Entrega')}`, field: 'direccionEntrega', sortable: true },
    { name: `${t('Status')}`, field: 'status', sortable: true },
    { name: `${t('Entrega Cte')}`, field: 'fechaEntregaCliente', sortable: false },
    { name: `${t('EIR')}`, field: 'EIR', sortable: true },
    { name: `${t('Expediente')}`, field: 'expediente', sortable: true },
    { name: `${t('Archivos')}`, field: 'archivos', sortable: false },
    { name: `${t('Acciones')}`, field: 'acciones', sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.referencia.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroInterno.toLowerCase().includes(search.toLowerCase()) ||
          comment.contenedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.importador.toLowerCase().includes(search.toLowerCase()) ||
          comment.apoyo.toLowerCase().includes(search.toLowerCase()) ||
          comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedimento.toLowerCase().includes(search.toLowerCase()) ||
          comment.modalidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.puerto.toLowerCase().includes(search.toLowerCase()) ||
          comment.direccionEntrega.toLowerCase().includes(search.toLowerCase()) ||
          
          comment.valorFactura.toString().includes(search)
      );
    }
    // if (selectedNaviera) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idNavieras.includes(selectedNaviera)
    //   );
    // }

    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedDuplicado) {
      computedComments = computedComments.filter((e) =>
        e.duplicado.includes(selectedDuplicado)
      );
    }

    // if (selectedAgente) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idAgentes.includes(selectedAgente)
    //   );
    // }

    // if (selectedForwarder) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idForwarders.includes(selectedForwarder)
    //   );
    // }

    // if (selectedPuerto) {
    //   computedComments = computedComments.filter((e) =>
    //     e.puerto.includes(selectedPuerto)
    //   );
    // }

    // if (selectedModalidad) {
    //   computedComments = computedComments.filter((e) =>
    //     e.modalidad.includes(selectedModalidad)
    //   );
    // }
    // if (selectedAsegurado) {
    //   computedComments = computedComments.filter((e) =>
    //     e.asegurado.includes(selectedAsegurado)
    //   );
    // }

    if (selectedStatus) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(selectedStatus)
      );
    }

    if (selectedEIR) {
      computedComments = computedComments.filter((e) =>
        e.EIR.includes(selectedEIR)
      );
    }
    if (selectedExpediente) {
      computedComments = computedComments.filter((e) =>
        e.expediente.includes(selectedExpediente)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedMayorQue) {
      computedComments = computedComments.filter(
        (e) => e.numero >= selectedMayorQue
      );
    }

    if (selectedMenorQue) {
      computedComments = computedComments.filter(
        (e) => e.numero <= selectedMenorQue
      );
    }

    // if (selectedPendiente) {
    //   computedComments = computedComments.filter((e) =>
    //     e.entregaCliente.includes(selectedPendiente)
    //   );
    // }

    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(selectedActivo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != 'totalCantidad' &&
      sorting.field != 'totalGeneral' &&
      sorting.field != 'valorFactura'
    ) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === 'asc' &&
      (sorting.field == 'totalCantidad' ||
        sorting.field == 'totalGeneral' ||
        sorting.field == 'valorFactura')
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === 'desc' &&
      (sorting.field == 'totalCantidad' ||
        sorting.field == 'totalGeneral' ||
        sorting.field == 'valorFactura')
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    // selectedNaviera,
    selectedCliente,
    // selectedAgente,
    // selectedForwarder,
    // selectedPuerto,
    // selectedModalidad,
    // selectedAsegurado,
    selectedStatus,
    selectedEIR,
    selectedExpediente,
    // selectedPendiente,
    selectedActivo,
    selectedMayorQue,
    selectedMenorQue,
    selectedDuplicado,
  ]);

  async function EditArticulos(idOC, numeroContenedor) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: '',
        descripcion: '',
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroContenedor(numeroContenedor);
    await axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              descripcion: a.descripcion,
              precio: a.precio,
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosContenedor(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulos();
  }

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleChangeInputExistentesCantidad = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = values.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

  const saveContenedor = async (event) => {
    event.preventDefault();
    toggleProgreso();

    let totalArticulos = inputFields.length + articulosContenedor.length;

    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_CONTENEDORES_EDIT,
          {
            totalGeneral: totalGeneral_edit,
            totalCantidad: totalCantidad_edit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != '' && a.cantidad > 0) {
              axios
                .post(
                  URL_ARTICULOS_CONTENEDOR,
                  {
                    contenedores: idEdit,
                    articulos: a.articulos,
                    descripcion: a.descripcion,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        'app_token'
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: 'Editar Contenedor',
                          detalle: `${numeroContenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              'app_token'
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire('Good job!', 'Creado con exito', 'success');
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!',
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
              // cerrar if
            } else {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: 'Editar Contenedor',
                      detalle: `${numeroContenedor}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          'app_token'
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire('Good job!', 'Creado con exito', 'success');
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Something went wrong!',
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              }
            }
          });

          articulosContenedor.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_CONTENEDOR}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      'app_token'
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: 'Editar Contenedor',
                        detalle: `${numeroContenedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            'app_token'
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire('Good job!', 'Creado con exito', 'success');
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Something went wrong!',
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function EditStatus(
    id,
    // bl,
    // pl,
    // factura,
    numeroInterno,
    // referencia,
    // documentos,
    // telex,
    // toquePiso,
    // revalidacion,
    // fichaTecnica,
    // pagoPedimento,
    // modulacion,
    // retornoVacio,
    // salidaPuerto,
    // salidaRuta,
    // maniobras,
    // entregaCliente,
    status,
    EIR,
    expediente,
    // fechaEntradaPuerto,
    // fechaDocumentos,
    // fechaTelex,
    // fechaToquePiso,
    // fechaRevalidacion,
    // fechaFichaTecnica,
    // fechaPagoPedimento,
    // fechaModulacion,
    // fechaRetornoVacio,
    // fechaSalidaPuerto,
    // fechaSalidaRuta,
    // fechaManiobras,
    fechaEntregaCliente,
    // fechaFactura,
    // fechaBl,
    // fechaPl
  ) {
    setid(id);
    // setbl(bl);
    // setpl(pl);
    // setfactura(factura);
    setnumeroInterno(numeroInterno);
    // setReferencia(referencia);
    // setdocumentos(documentos);
    // settelex(telex);
    // settoquePiso(toquePiso);
    // setrevalidacion(revalidacion);
    // setfichaTecnica(fichaTecnica);
    // setpagoPedimento(pagoPedimento);
    // setmodulacion(modulacion);
    // setretornoVacio(retornoVacio);
    // setsalidaPuerto(salidaPuerto);
    // setsalidaRuta(salidaRuta);
    // setmaniobras(maniobras)
    // setentregaCliente(entregaCliente);
    setStatus(status);
    setEIR(EIR);
    setExpediente(expediente);
    // setfechaEntradaPuerto(fechaEntradaPuerto);
    // setfechaDocumentos(fechaDocumentos);
    // setfechaTelex(fechaTelex);
    // setfechaToquePiso(fechaToquePiso);
    // setfechaRevalidacion(fechaRevalidacion);
    // setfechaFichaTecnica(fechaFichaTecnica);
    // setfechaPagoPedimento(fechaPagoPedimento);
    // setfechaModulacion(fechaModulacion);
    // setfechaRetornoVacio(fechaRetornoVacio);
    // setfechaSalidaPuerto(fechaSalidaPuerto);
    // setfechaSalidaRuta(fechaSalidaRuta);
    // setfechaManiobras(fechaManiobras)
    setfechaEntregaCliente(fechaEntregaCliente);
    // setfechaFactura(fechaFactura);
    // setfechaBl(fechaBl);
    // setfechaPl(fechaPl);
    toggleStatus();
  }

  function updateStatus(property, value, nombreFecha, fechaS) {
    if (fechaS == '' || fechaS == undefined) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'La fecha no puede estar vacia',
      });
    } else {
      const data = {
        [property]: value,
        [nombreFecha]: fechaS,
        status,
        EIR,
        expediente
      };

      axios
        .patch(`${URL_CONTENEDORES}/${id}`, data, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        })
        .then(() => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Actualizado con Exito',
            showConfirmButton: false,
            timer: 2000,
          });

          let temp = comments.map((a) => {
            if (a._id === id) {
              a[nombreFecha] = fechaS;
              a[property] = value;
              a.status = status;
              a.EIR = EIR;
              a.expediente = expediente
            }
            return a;
          });
          setComments(temp);
            setTimeout(() => {
          window.location.reload();
        }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  }

  function updateOnlyStatus() {
    axios
      .patch(
        `${URL_CONTENEDORES}/${id}`,
        {
          status,
          EIR,
          expediente,
          fechaEntregaCliente
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Actualizado con Exito',
          showConfirmButton: false,
          timer: 2000,
        });

        let temp = comments.map((a) => {
          if (a._id === id) {
            a.status = status;
            a.EIR = EIR;
            a.expediente = expediente
          }
          return a;
        });
        setComments(temp);

        setTimeout(() => {
          setModalStatus(false);
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const calcula = (e) => {
    setTotalUSD(e);
    setTotal(parseFloat(e) * parseFloat(tipoCambio));
  };

  const calculaTipoCambio = (e) => {
    setTipoCambio(e);
    setTotal(parseFloat(totalUSD) * parseFloat(e));
  };

  function saveGasto() {
    setValidaBoton(false);
    axios
      .post(
        URL_GASTOS_CONTENEDOR,
        {
          fecha: fechaGasto,
          totalUSD,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          contenedores: selectedContenedor,
          proveedores: selectedProveedor,
          clientes: selectedClienteGasto,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Crear Gasto',
            detalle: `Fecha: ${fecha} / Concepto: ${selectedConcepto} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        );
        Swal.fire('Good job!', 'Creado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  function saveCargo() {
    setValidaBoton(false);
    axios
      .post(
        URL_CARGOS_CONTENEDOR,
        {
          fecha: fechaGasto,
          totalUSD,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          contenedores: selectedContenedor,
          clientes: selectedClienteGasto,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Crear Cargo',
            detalle: `Fecha: ${fecha} / Concepto: ${selectedConcepto} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        );
        Swal.fire('Good job!', 'Creado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  function excelOC() {
    var option = {};

    option.fileName = numeroInterno;

    option.datas = [
      {
        sheetData: [
          {
            BL: fechaBl,
            PL: fechaPl,
            Factura: fechaFactura,
            FichaTecnica: fechaFichaTecnica,
            Telex: fechaTelex,
            ToquePiso: fechaToquePiso,
            Revalidacion: fechaRevalidacion,
            PagoPedimento: fechaPagoPedimento,
            Documentos: fechaDocumentos,
            Modulacion: fechaModulacion,
            SalidaPuerto: fechaSalidaPuerto,
            SalidaRuta: fechaSalidaRuta,
            Maniobras: fechaManiobras,
            EntregaCliente: fechaEntregaCliente,
            RetornoVacio: fechaRetornoVacio,
          },
        ],
        sheetName: numeroInterno,
        sheetFilter: [
          'BL',
          'PL',
          'Factura',
          'FichaTecnica',
          'Telex',
          'ToquePiso',
          'Revalidacion',
          'PagoPedimento',
          'Documentos',
          'Modulacion',
          'SalidaPuerto',
          'SalidaRuta',
          'Maniobras',
          'EntregaCliente',
          'RetornoVacio',
        ],
        sheetHeader: [
          'BL',
          'PL',
          'Factura',
          'FichaTecnica',
          'Telex',
          'ToquePiso',
          'Revalidacion',
          'PagoPedimento',
          'Documentos',
          'Modulacion',
          'SalidaPuerto',
          'SalidaRuta',
          'Maniobras',
          'EntregaCliente',
          'RetornoVacio',
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

//   async function registrarSG(id, naviera, contenedor) {

//     axios
//     .patch(
//       `${URL_CONTENEDORES}AltaRastreo/${id}`,
//       {
//         navieras: naviera,
//         contenedor: contenedor
//       },
//       {
//         headers: {
//           Authorization: `Bearer: ${localStorage.getItem(
//             'app_token'
//           )}`,
//         },
//       }
//     )
//     .then(() => {
//       Swal.fire('Good job!', 'Creado con exito', 'success');
//       setTimeout(() => {
//         window.location.reload();
//       }, 1000);
//     })
//     .catch((error) => {
//       Swal.fire({
//         icon: 'error',
//         title: 'Oops...',
//         text: 'Something went wrong!',
//         footer: `${error.response.data}`,
//       });
//       console.log(error);
//     });
    
//   }

//   function crearMapa(polLatitude,
//     polLongitude,
//     podLatitude,
//     podLongitude,
//     vesselLatitude,
//     vesselLongitude,
//     etaReal
//   ){

// const etaRealDate = new Date(etaReal)
// etaRealDate.setHours(0, 0, 0, 0);
// hoy.setHours(0, 0, 0, 0);
//   const diasDiferencia = Math.floor((Date.UTC(etaRealDate.getFullYear(), etaRealDate.getMonth(), etaRealDate.getDate()) - 
//                                    Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())) / (1000 * 60 * 60 * 24));

//     setDiasLlegada(diasDiferencia)

//     setOriginCoords([polLatitude, polLongitude]);  // Ningbo, China (puerto de origen)
//     setVesselCoords([vesselLatitude, vesselLongitude]);  // Posición actual del barco
//     setDestinationCoords([podLatitude, podLongitude]);  // Lázaro Cárdenas, México (puerto de destino)
  
//     // Ruta con puntos intermedios
//     setCoordenadasMapa([
//       // [polLatitude, polLongitude], 
//       [vesselLatitude, vesselLongitude], 
//       [podLatitude, podLongitude],
//       // [30, 140],  // Punto intermedio 1 en el océano
//       // [40, -160],
//       // [20, -130],  // Punto intermedio 2 en el océano
//     ]);

//     toggleMapa()
//   }

  // Foto Packing
  function guardaFotosPacking() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_PACKING, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              packing: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoPacking(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PACKING}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoPacking();
  }

    // Foto BL
    function guardaFotosBL() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_BL, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                bl: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoBL(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BL}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          // console.log("hola2", data.data.resources)
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoBL();
    }

      // Foto Invoice
  function guardaFotosInvoice() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_INVOICE, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              invoice: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoInvoice(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_INVOICE}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoInvoice();
  }

    // Foto Validacion
    function guardaFotosValidacion() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_VALIDACION, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                validacion: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoValidacion(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_VALIDACION}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          // console.log("hola2", data.data.resources)
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoValidacion();
    }

      // Foto Garantia
  function guardaFotosGarantia() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_GARANTIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              garantia: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoGarantia(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_GARANTIA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoGarantia();
  }

    // Foto Transporte
    function guardaFotosTransporte() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_TRANSPORTE, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                transporte: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoTransporte(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_TRANSPORTE}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          // console.log("hola2", data.data.resources)
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoTransporte();
    }
    function borrarFoto(id) {

      axios.post(`${URL_DELMEDIA}/${id}`, {}, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
  
      .then(() => {
  
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
  
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
      
  
      // setFile();
      // setPhoto([]);
    }

    function jalaArchivos(id, packing, bl, invoice, validacion, garantia, transporte) {
      setIdContenedor(id);
      setPacking(packing);
      setBlArchivo(bl);
      setInvoice(invoice);
      setValidacion(validacion);
      setGarantia(garantia);
      setTransporte(transporte);
      toggleFotos();
    }

function formatearETA(valor) {
  if (typeof valor === "string" && valor.includes("/")) {
    const [d, m, a] = valor.split("/");
    return `${a}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  } else if (typeof valor === "number") {
    const fecha = new Date(Math.round((valor - 25569) * 86400 * 1000));
    return fecha.toISOString().split("T")[0];
  }
  return "";
}

function importarArchivo(event) {
  const target = event.target;
  const name = target.name;

  if (name === "file") {
    Swal.fire({
      title: "Procesando archivo...",
      html: "Por favor espera mientras se importan los datos.",
      allowOutsideClick: false,
      backdrop: true,
      didOpen: () => Swal.showLoading(),
    });

    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        // ✅ Filtro para eliminar filas completamente vacías o con solo espacios
        const A1 = XLSX.utils
          .sheet_to_json(sheet)
          .filter((row) =>
            Object.values(row).some(
              (value) =>
                value !== null &&
                value !== undefined &&
                value.toString().trim() !== ""
            )
          );

        const clientesMap = {};
        clientes.forEach((cont) => {
          clientesMap[cont.nombre_comercial] = cont;
        });

        const nuevosCampos = [];
        const referenciasVistas = new Set();
        const referenciasDuplicadas = new Set();
        const clientesNoEncontrados = [];

        for (const a of A1) {
          const cont = clientesMap[a.CLIENTE];
          const referencia = a.REFERENCIA?.toString().trim();

          if (cont) {
            if (referenciasVistas.has(referencia)) {
              referenciasDuplicadas.add(referencia);
            } else {
              referenciasVistas.add(referencia);
            }

            nuevosCampos.push({
              id: uuidv4(),
              cliente: cont.nombre_comercial,
              idCliente: cont._id,
              referencia: referencia,
              referenciaCliente: a.REFERENCIACLIENTE?.toString() || "",
              contenedor: a.CONTENEDOR,
              eta: formatearETA(a.ETA),
              importador: a.IMPORTADOR,
              apoyo: a.APOYO,
              articulo: a.ARTICULO,
              valorFactura: a.VALORFACTURA,
              pedimento: a.PEDIMENTO?.toString() || "",
              modalidad: a.MODALIDAD,
              puerto: a.PUERTO,
              direccionEntrega: a.DIRECCIONENTREGA,
            });
          } else {
            clientesNoEncontrados.push(a.CLIENTE);
          }
        }

        // ✅ Reemplaza completamente los datos actuales
        setInputFieldsContenedores(nuevosCampos);
        setTotalContenedores(nuevosCampos.length);
        Swal.close();

        // 🔔 Mostrar advertencias si hay
        const mensajes = [];

        if (clientesNoEncontrados.length > 0) {
          mensajes.push(
            `Clientes no encontrados: ${clientesNoEncontrados.join(", ")}`
          );
        }

        if (referenciasDuplicadas.size > 0) {
          mensajes.push(
            `Referencias duplicadas: ${Array.from(referenciasDuplicadas).join(
              ", "
            )}`
          );
        }

        if (mensajes.length > 0) {
          Swal.fire({
            title: "Advertencias en la importación",
            html: mensajes.join("<br><br>"),
            icon: "warning",
            confirmButtonText: "Entendido",
          });
        }
      } catch (err) {
        Swal.close();
        Swal.fire({
          title: "Error",
          text: "Hubo un error al procesar el archivo.",
          icon: "error",
        });
        console.error(err);
      }
    };

    reader.readAsArrayBuffer(target.files[0]);
  }
}



// console.log("hola", inputFieldsContenedores.length - 1)
        const saveContenedoresArchivo = async () => {

    setValidaBoton(false);
    toggleProgreso();
    let totalPedido = inputFieldsContenedores.length - 1;
    
    try {
        await Promise.all(
          inputFieldsContenedores
            .filter((e) => e.referencia != "")
            .map((a) =>
              axios.post(
                `${URL_CONTENEDORES}`,
                {
                  fecha: endDate,
                  navieras: "6744d2e1fd6a78a7d65c0fc8",
                  clientes: a.idCliente,
                  agentes: "67bf6db86d2087cd81dfe909",
                  forwarders: "6744d2f0fd6a78a7d65c0fcf",
                  numeroInterno: a.referenciaCliente,
                  contenedor: a.contenedor,
                  etaEstimada: a.eta,
                  etaReal: a.eta,
                  totalGastos: 0,
                  totalGeneral:0,
                  totalCantidad:0,
                  observaciones: "NA",
                  totalCargos: 0,
                  puerto: a.puerto,
                  puertoOrigen: "NA",
                  numeroBl: "NA",
                  modalidad: a.modalidad,
                  direccionEntrega: a.direccionEntrega,
                  terminales: "659751b809da69446cc05f3d",
                  programas: "65984b7d111f341061f6c353",
                  patentes: "66db35dea6b7de33346cd392",
                  asegurado: "No Aplica",
                  rastreo: "No",
                  pesoTotal: 0,
                  referencia: a.referencia,
                  importador: a.importador,
                  apoyo: a.apoyo,
                  articulo: a.articulo,
                  valorFactura: a.valorFactura,
                  pedimento: a.pedimento,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
            )
        );

        await axios.post(
            URL_LOGS,
            {
                tipo: "Subir Contenedores",
                detalle: `Varios`,
                user: user.id,
            },
            {
                headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
            }
        );

        Swal.fire("Good job!", "Creado con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
        });
        console.log(error);
        setValidaBoton(true);
    }
};

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menuContenedores ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.contenedoresCreate ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ContenedoresCreate"
                >
                  {t("Nuevo")}
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  {t("Nuevo")}
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuContenedores"
                className="btn btn-danger"
                id="botonListado"
              >
                {t("Regresar")}
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {/* <Button
                  size='sm'
                  className='btn'
                  color='success'
                  onClick={toggleETA}
                >
                  ETAs
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={toggleArchivo}
                >
                  Archivo <i class="fas fa-upload"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>{t("Enviar Listado Contenedores")}</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                {t("Enviar")}
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">{t("Contenedores")}</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">{t("Fecha Inicio")}</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">{t("Fecha Fin")}</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">{t("Pendientes")}</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedPendiente}
                required
                onChange={(e) => {
                  setSelectedPendiente(e.target.value);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="No">{t("Pendiente")}</option>
                <option value="Si">{t("Entregado")}</option>
              </Input>
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">{t("Activo")}</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedActivo}
                required
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="Si">{t("Activo")}</option>
                <option value="No">{t("Cancelado")}</option>
              </Input>
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">{t("Mayor Que")}</Label>
              <Input
                bsSize="sm"
                type="number"
                value={selectedMayorQue}
                required
                onChange={(e) => {
                  setSelectedMayorQue(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">{t("Menor Que")}</Label>
              <Input
                bsSize="sm"
                type="number"
                value={selectedMenorQue}
                required
                onChange={(e) => {
                  setSelectedMenorQue(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedNaviera}
                  onChange={(e) => {
                    setSelectedNaviera(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Naviera') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">{t("Selecciona")}</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedAgente}
                  onChange={(e) => {
                    setSelectedAgente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Agente') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedForwarder}
                  onChange={(e) => {
                    setSelectedForwarder(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Forwarder') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td> */}
              {/* <td></td> */}
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  placeholder='Puerto'
                  value={selectedPuerto}
                  required
                  onChange={(e) => {
                    setSelectedPuerto(e.target.value);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='Aeropuero CDMX'>Aeropuero CDMX</option>
                  <option value='Laredo'>Laredo</option>
                  <option value='Lazaro Cardenas'>Lazaro Cardenas</option>
                  <option value='Manzanillo'>Manzanillo</option>
                  <option value='Progreso'>Progreso</option>
                  <option value='Tijuana'>Tijuana</option>
                  <option value='Veracruz'>Veracruz</option>
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  placeholder='Modalidad'
                  value={selectedModalidad}
                  required
                  onChange={(e) => {
                    setSelectedModalidad(e.target.value);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='Tren'>Tren</option>
                  <option value='Camion'>Camion</option>
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  placeholder='Asegurado'
                  value={selectedAsegurado}
                  required
                  onChange={(e) => {
                    setSelectedAsegurado(e.target.value);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='No'>No</option>
                  <option value='Si'>Si</option>
                  <option value='No Aplica'>No Aplica</option>
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: '0px' }}></td> */}
               <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedDuplicado}
                  onChange={(e) => {
                    setSelectedDuplicado(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">{t("Selecciona")}</option>
                  <option value="Si">{t("Duplicado")}</option>
                  <option value="No">{t("No Duplicado")}</option>
                  
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  type="select"
                  bsSize="sm"
                  value={selectedStatus}
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Pendiente">Pendiente</option>
                  {/* <option value='Ficha Tecnica'>Ficha Tecnica</option>
                  <option value='Toque Piso'>Toque Piso</option>
                  <option value='Telex'> Telex</option>
                  <option value='Naviera Freno Demoras'>
                    Naviera Freno Demoras
                  </option>
                  <option value='Cambio Patente'>Cambio Patente</option>
                  <option value='Revalidacion'>Revalidacion</option>
                  <option value='Pago Pedimento'>Pago Pedimento</option>
                  <option value='Por Modular'>Por Modular</option>
                  <option value='Por Documentar Tren'>
                    Por Documentar Tren
                  </option>
                  <option value='Por subir Tren'>Por subir Tren</option>
                  <option value='Maniobra Transportista'>
                    Maniobra Transportista
                  </option>
                  <option value='Patio Transportista'>
                    Patio Transportista
                  </option>
                  <option value='A1'>A1</option>
                  <option value='PAMA'>PAMA</option>
                  <option value='ROJO'>ROJO</option>
                  <option value='OVT'>OVT</option>
                  <option value='RETENIDO DESDE LLEGADA'>RETENIDO DESDE LLEGADA</option>
                  <option value='Bodega Tortons'>Bodega Tortons</option>
                  <option value='En Tren'>En Tren</option>
                  <option value='Pendiente Maniobras'>Pendiente Maniobras</option> */}
                  <option value="Entregado">Entregado</option>
                  <option value="Cancelado">Cancelado</option>
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  type="select"
                  bsSize="sm"
                  value={selectedEIR}
                  onChange={(e) => {
                    setSelectedEIR(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Abierto">Abierto</option>
                  <option value="Cerrado">Cerrado</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  type="select"
                  bsSize="sm"
                  value={selectedExpediente}
                  onChange={(e) => {
                    setSelectedExpediente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Abierto">Abierto</option>
                  <option value="Cerrado">Cerrado</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}></td>
            </tr>
            <tbody>
              {commentsData
                .sort((a, b) => (a.numero < b.numero ? 1 : -1))
                .map((a) => {
                  return (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.referencia}</td>
                      <td>{a.numeroInterno}</td>
                      <td>{a.contenedor}</td>
                      <td>{a.etaReal}</td>
                      <td>{a.importador}</td>
                      <td>{a.apoyo}</td>
                      <td>{a.articulo}</td>
                      <td>{a.valorFactura}</td>
                      <td>{a.pedimento}</td>
                      <td>{a.modalidad}</td>
                      <td>{a.puerto}</td>
                      <td>{a.direccionEntrega}</td>
                      <td>{a.status}</td>
                      {a.status == "Entregado" ? (
                        <td>{a.fechaEntregaCliente}</td>
                      ) : (
                        <td></td>
                      )}
                      <td>{a.EIR}</td>
                      <td>{a.expediente}</td>
                      {/* <td style={{ paddingTop: '0px' }}>{a.fechaRevalidacion}</td> */}
                      {/* <td style={{ paddingTop: '0px' }}>
                      {a.fechaEntregaCliente}
                    </td> */}
                      {/* Fotos */}
                      <td>
                        <Button
                          size="sm"
                          style={{ color: "yellow" }}
                          onClick={(e) =>
                            jalaArchivos(
                              a._id,
                              a.packing,
                              a.bl,
                              a.invoice,
                              a.validacion,
                              a.garantia,
                              a.transporte
                            )
                          }
                        >
                          <i class="far fa-folder"></i>
                        </Button>
                      </td>

                      <td style={{ paddingTop: "0px" }}>
                        {/* <Button
                        size='sm'
                        className='btn'
                        color='danger'
                        onClick={(e) =>
                          PDFOC(
                            a.fecha,
                            a.idNavieras,
                            a.navieras,
                            a.clientes,
                            a.agentes,
                            a.totalCantidad,
                            a.totalGeneral,
                            a.observaciones,
                            a.numero,
                            a._id
                          )
                        }
                      >
                        <i class='far fa-file-pdf'></i>
                        </Button>  */}
                        {/* {a.rastreo == 'No' && a.idNavieras != "65a093c4b196000019bbeca4" ? (
                      <Button
                      size='sm'
                        color='success'
                        onClick={(e) =>{
                          registrarSG(a._id, a.navieras, a.contenedor)
                        }
                        }
                      >
                        SG
                      </Button>
                      ):(
                        <Button
                          size='sm'
                        color='success'
                          disabled
                          >
                            SG
                          </Button>)}
                      {a.mapa !== 'No' ? (
                      <Button
                      size='sm'
                        onClick={(e) =>{
                          crearMapa(a.polLatitude,
                            a.polLongitude,
                            a.podLatitude,
                            a.podLongitude,
                            a.vesselLatitude,
                            a.vesselLongitude,
                            a.etaReal
                          )
                        }
                        }
                      >
                        <i class='fas fa-map'></i>
                      </Button>
                      ):(
                        <Button
                          size='sm'
                          disabled
                          >
                            <i class='fas fa-map'></i>
                          </Button>)} */}
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) =>
                            jalaInfo(
                              a._id,
                              a.fecha,
                              a.numeroInterno,
                              a.referencia,
                              a.contenedor,
                              a.etaReal,
                              a.importador,
                              a.apoyo,
                              a.articulo,
                              a.valorFactura,
                              a.pedimento,
                              a.modalidad,
                              a.puerto,
                              a.direccionEntrega,
                              a.idClientes,
                              a.totalCargos,
                              a.totalGastos
                            )
                          }
                        >
                          <i class="far fa-edit"></i>
                        </Button>
                        <Button
                          color="warning"
                          id="CambiarCliente"
                          title="Cambiar Cliente"
                          size="sm"
                          onClick={(e) =>
                            jalaCambiarCliente(a._id, a.contenedor, a.clientes)
                          }
                        >
                          <i class="fas fa-user-tag"></i>
                        </Button>
                        {/* <Button
                        color='info'
                        id='Editar'
                        size='sm'
                        onClick={(e) => EditArticulos(a._id, a.numero)}
                      >
                        <i class='fas fa-cart-plus'></i>
                      </Button> */}

                        <Button
                          color="success"
                          id="Editar"
                          size="sm"
                          onClick={(e) =>
                            EditStatus(
                              a._id,
                              // a.bl,
                              // a.pl,
                              // a.factura,
                              a.numeroInterno,
                              // a.referencia,
                              // a.documentos,
                              // a.telex,
                              // a.toquePiso,
                              // a.revalidacion,
                              // a.fichaTecnica,
                              // a.pagoPedimento,
                              // a.modulacion,
                              // a.retornoVacio,
                              // a.salidaPuerto,
                              // a.salidaRuta,
                              // a.maniobras,
                              // a.entregaCliente,
                              a.status,
                              a.EIR,
                              a.expediente,
                              // a.fechaEntradaPuerto,
                              // a.fechaDocumentos,
                              // a.fechaTelex,
                              // a.fechaToquePiso,
                              // a.fechaRevalidacion,
                              // a.fechaFichaTecnica,
                              // a.fechaPagoPedimento,
                              // a.fechaModulacion,
                              // a.fechaRetornoVacio,
                              // a.fechaSalidaPuerto,
                              // a.fechaSalidaRuta,
                              // a.fechaManiobras,
                              a.fechaEntregaCliente
                              // a.fechaFactura,
                              // a.fechaBl,
                              // a.fechaPl
                            )
                          }
                        >
                          <i class="fas fa-calendar-check"></i>
                        </Button>
                        {user.contenedoresEntrega ? (
                          <Baja
                            idStatus={a._id}
                            is_active={a.activo}
                            URL_BAJA={process.env.REACT_APP_URL_CONTENEDORES}
                          />
                        ) : undefined}
                        {/* <Button
                        color="primary"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setSelectedContenedor(a._id);
                          setSelectedClienteGasto(a.idClientes);
                          setnumeroInterno(a.numeroInterno);
                          toggleGastos();
                        }}
                      >
                        <i class="fas fa-dollar-sign"></i>
                      </Button>
                      <Button
                        color="info"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setSelectedContenedor(a._id);
                          setSelectedClienteGasto(a.idClientes);
                          setnumeroInterno(a.numeroInterno);
                          toggleCargos();
                        }}
                      >
                        <i class="fas fa-plus"></i>
                      </Button> */}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            {t("Editar")} {t("Contenedor")} {numeroContenedor}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>{t("Fecha")}</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
                <Label className="mr-sm-2">{t("Cliente")}</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={idClientes}
                  disabled
                >
                   <option value="">{t("Selecciona")}</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
                <small className="text-muted">
                  {t('Usa el boton "Cambiar Cliente" para reasignar el cliente.')}
                </small>
              </Col>

            <Col md={3}>
              <Label>{t("Referencia Cliente")}</Label>
              <Input
                type="text"
                placeholder="NumeroInterno"
                value={numeroInternoEdit}
                required
                onChange={(e) => {
                  setNumeroInternoEdit(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("No. Contenedor")}</Label>
              <Input
                type="text"
                placeholder="Contenedor"
                value={contenedor}
                required
                onChange={(e) => {
                  setContenedor(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label>{t("Referencia")}</Label>
              <Input
                type="text"
                placeholder="Referencia"
                value={referencia}
                required
                onChange={(e) => {
                  setReferencia(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Fecha")} ETA</Label>
              <Input
                type="date"
                placeholder="Fecha ETA"
                value={fechaETAReal}
                required
                onChange={(e) => {
                  setETAReal(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Apoyo")}
              </Label>
              <Input
                type="text"
                placeholder="Apoyo"
                value={apoyo}
                required
                onChange={(e) => {
                  setApoyo(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Articulo")}
              </Label>
              <Input
                type="text"
                placeholder="Articulo"
                value={articulo}
                required
                onChange={(e) => {
                  setArticulo(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Valor Factura")}
              </Label>
              <Input
                type="number"
                placeholder="ValorFactura"
                value={valorFactura}
                required
                onChange={(e) => {
                  setValorFactura(e.target.value);
                }}
              />
            </Col>

            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Pedimento")}
              </Label>
              <Input
                type="text"
                placeholder="Pedimento"
                value={pedimento}
                required
                onChange={(e) => {
                  setPedimento(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Modalidad")}</Label>
              <Input
                type="text"
                placeholder="Modalidad"
                value={modalidad}
                required
                onChange={(e) => {
                  setModalidad(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Puerto")}</Label>
              <Input
                type="text"
                placeholder="Puerto"
                value={puerto}
                required
                onChange={(e) => {
                  setPuerto(e.target.value);
                }}
              />
              {/* <option value="">Selecciona</option>
                  <option value="Aeropuero CDMX">Aeropuero CDMX</option>
                  <option value="Laredo">Laredo</option>
                  <option value="Lazaro Cardenas">Lazaro Cardenas</option>
                  <option value="Manzanillo">Manzanillo</option>
                  <option value="Progreso">Progreso</option>
                  <option value="Tijuana">Tijuana</option>
                  <option value="Veracruz">Veracruz</option>
                </Input> */}
            </Col>
          </Row>
          <Row>
             <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Importador")}
              </Label>
              <Input
                type="text"
                placeholder="Importador"
                value={importador}
                required
                onChange={(e) => {
                  setImportador(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Direccion de Entrega")}</Label>
              <Input
                type="text"
                placeholder="Direccion Entrega"
                value={direccionEntrega}
                required
                onChange={(e) => {
                  setDireccionEntrega(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editContenedores}>
            {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="md" isOpen={modalCambiarCliente} toggle={toggleCambiarCliente}>
        <ModalHeader toggle={toggleCambiarCliente}>
          <h4>{t("Cambiar Cliente")}</h4>
        </ModalHeader>
        <ModalBody>
          <p>
            {t("Contenedor")}: <b>{contenedorCambiarCliente}</b>
          </p>
          <p>
            {t("Cliente")} {t("actual")}: <b>{clienteActualCambiar}</b>
          </p>
          <Alert color="warning" style={{ fontSize: "0.85rem" }}>
            {t(
              "Se moveran a este contenedor todos sus cargos, abonos y el estado de cuenta del cliente anterior al nuevo cliente."
            )}
          </Alert>
          <Label className="mr-sm-2">{t("Cliente")} {t("nuevo")}</Label>
          <Input
            className="col-sm-12"
            type="select"
            value={clienteNuevo}
            required
            onChange={(e) => {
              setClienteNuevo(e.target.value);
            }}
          >
            <option value="">{t("Selecciona")}</option>
            {clientes
              .sort((a, b) =>
                a.nombre_comercial > b.nombre_comercial ? 1 : -1
              )
              .map((a) => {
                return <option value={a._id}>{a.nombre_comercial}</option>;
              })}
          </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleCambiarCliente}>
            {t("Cancelar")}
          </Button>
          <Button color="success" onClick={cambiarClienteContenedor}>
            {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>
            {"Editar"} {t("Articulos")} {t("Contenedor")} {numeroContenedor}
          </h4>
          <h4>
            TOTAL {totalCantidad_edit} pzas. /{" "}
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalGeneral_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">{t("Articulos")}</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">{t("Descripcion")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("Cantidad")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("Precio")}</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {articulosContenedor.map((ao) => (
            <div key={ao.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={ao.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticuloExistentes(ao.id, event);
                    }}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="descripcion"
                    type="text"
                    placeholder="descripcion"
                    value={ao.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={ao.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentesCantidad(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={ao.precio}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={ao.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}

          {/* Agregar mas articulos */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="descripcion"
                    type="text"
                    placeholder="descripcion"
                    value={inputField.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTAL {totalCantidad_edit} pzas. /{" "}
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(totalGeneral_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={saveContenedor}>
            {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>{t("Progreso")}</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            {t("Este proceso puede tardar varios segundos.")}
            <br />
            {t("Por favor no cierre ni refresque su navegador.")}
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalStatus} toggle={toggleStatus}>
        <ModalHeader toggle={toggleStatus}>
          <h4>
            {t("Status")} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          {/* <Row>
            <Button size='sm' className='btn' color='primary' onClick={excelOC}>
              Excel <i class='far fa-file-excel'></i>
            </Button>
          </Row> */}
          <Row>
            <Col md={4}>
              <Label>Status</Label>
              <Input
                type="select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="Pendiente">Pendiente</option>
                {/* <option value='Ficha Tecnica'>Ficha Tecnica</option>
                <option value='Toque Piso'>Toque Piso</option>
                <option value='Telex'> Telex</option>
                <option value='Naviera Freno Demoras'>
                  Naviera Freno Demoras
                </option>
                <option value='Cambio Patente'>Cambio Patente</option>
                <option value='Revalidacion'>Revalidacion</option>
                <option value='Pago Pedimento'>Pago Pedimento</option>
                <option value='Por Modular'>Por Modular</option>
                <option value='Por Documentar Tren'>Por Documentar Tren</option>
                <option value='Por subir Tren'>Por subir Tren</option>
                <option value='Maniobra Transportista'>
                  Maniobra Transportista
                </option>
                <option value='Patio Transportista'>Patio Transportista</option>
                <option value='A1'>A1</option>
                  <option value='PAMA'>PAMA</option>
                  <option value='ROJO'>ROJO</option>
                  <option value='OVT'>OVT</option>
                  <option value='RETENIDO DESDE LLEGADA'>RETENIDO DESDE LLEGADA</option>
                  <option value='Bodega Tortons'>Bodega Tortons</option>
                  <option value='En Tren'>En Tren</option>
                  <option value='Pendiente Maniobras'>Pendiente Maniobras</option> */}
                {user.contenedoresEntrega ? (
                  <>
                    <option value="Entregado">Entregado</option>
                    <option value="Cancelado">Cancelado</option>
                  </>
                ) : undefined}
              </Input>
            </Col>
            {status == "Entregado" ? (
              <Col md={3} className="negro">
                <Label>Fecha Entrega</Label>
                <Input
                  type="date"
                  value={fechaEntregaCliente}
                  onChange={(e) => setfechaEntregaCliente(e.target.value)}
                />
              </Col>
            ) : undefined}
          </Row>
          <Row>

            <Col md={4}>
              <Label>EIR</Label>
              <Input
                type="select"
                value={EIR}
                onChange={(e) => setEIR(e.target.value)}
              >
                <option value="Pendiente">Pendiente</option>
                <option value="Abierto">Abierto</option>
                <option value="Cerrado">Cerrado</option>
              </Input>
            </Col>
            <Col md={4}>
              <Label>Expediente</Label>
              <Input
                type="select"
                value={expediente}
                onChange={(e) => setExpediente(e.target.value)}
              >
                <option value="Pendiente">Pendiente</option>
                <option value="Abierto">Abierto</option>
                <option value="Cerrado">Cerrado</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Button size="sm" type="submit" onClick={() => updateOnlyStatus()}>
            Actualizar
          </Button>
          <br />
          {/* <Row>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Concepto</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Fecha</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Realizado</Label>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>BL</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaBl}
                onChange={(e) => setfechaBl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{bl === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={bl === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'bl',
                    bl === 'Si' ? 'No' : 'Si',
                    'fechaBl',
                    fechaBl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Packing List</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPl}
                onChange={(e) => setfechaPl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{pl === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={pl === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'pl',
                    pl === 'Si' ? 'No' : 'Si',
                    'fechaPl',
                    fechaPl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Factura</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFactura}
                onChange={(e) => setfechaFactura(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{factura === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={factura === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'factura',
                    factura === 'Si' ? 'No' : 'Si',
                    'fechaFactura',
                    fechaFactura
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>FichaTecnica</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFichaTecnica}
                onChange={(e) => setfechaFichaTecnica(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{fichaTecnica === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={fichaTecnica === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'fichaTecnica',
                    fichaTecnica === 'Si' ? 'No' : 'Si',
                    'fechaFichaTecnica',
                    fechaFichaTecnica
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Telex</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaTelex}
                onChange={(e) => setfechaTelex(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{telex === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={telex === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'telex',
                    telex === 'Si' ? 'No' : 'Si',
                    'fechaTelex',
                    fechaTelex
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Toque de Piso</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaToquePiso}
                onChange={(e) => setfechaToquePiso(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{toquePiso === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={toquePiso === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'toquePiso',
                    toquePiso === 'Si' ? 'No' : 'Si',
                    'fechaToquePiso',
                    fechaToquePiso
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Revalidacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRevalidacion}
                onChange={(e) => setfechaRevalidacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{revalidacion === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={revalidacion === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'revalidacion',
                    revalidacion === 'Si' ? 'No' : 'Si',
                    'fechaRevalidacion',
                    fechaRevalidacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Pago Pedimento</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPagoPedimento}
                onChange={(e) => setfechaPagoPedimento(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{pagoPedimento === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={pagoPedimento === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'pagoPedimento',
                    pagoPedimento === 'Si' ? 'No' : 'Si',
                    'fechaPagoPedimento',
                    fechaPagoPedimento
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
         
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Modulacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaModulacion}
                onChange={(e) => setfechaModulacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{modulacion === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={modulacion === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'modulacion',
                    modulacion === 'Si' ? 'No' : 'Si',
                    'fechaModulacion',
                    fechaModulacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida de Puerto</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaPuerto}
                onChange={(e) => setfechaSalidaPuerto(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{salidaPuerto === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={salidaPuerto === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'salidaPuerto',
                    salidaPuerto === 'Si' ? 'No' : 'Si',
                    'fechaSalidaPuerto',
                    fechaSalidaPuerto
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida Ruta</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaRuta}
                onChange={(e) => setfechaSalidaRuta(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{salidaRuta === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={salidaRuta === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'salidaRuta',
                    salidaRuta === 'Si' ? 'No' : 'Si',
                    'fechaSalidaRuta',
                    fechaSalidaRuta
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Maniobras</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaManiobras}
                onChange={(e) => setfechaManiobras(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{maniobras === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={maniobras === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'maniobras',
                    maniobras === 'Si' ? 'No' : 'Si',
                    'fechaManiobras',
                    fechaManiobras
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          {user.contenedoresEntrega?(
            <>
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Entrega Cliente</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaEntregaCliente}
                onChange={(e) => setfechaEntregaCliente(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{entregaCliente === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={entregaCliente === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'entregaCliente',
                    entregaCliente === 'Si' ? 'No' : 'Si',
                    'fechaEntregaCliente',
                    fechaEntregaCliente
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          </>
        ):undefined}
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Retorno Vacio</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRetornoVacio}
                onChange={(e) => setfechaRetornoVacio(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{retornoVacio === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={retornoVacio === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'retornoVacio',
                    retornoVacio === 'Si' ? 'No' : 'Si',
                    'fechaRetornoVacio',
                    fechaRetornoVacio
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row> 
          <br /> */}
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalGastos} toggle={toggleGastos}>
        <ModalHeader toggle={toggleGastos}>
          <h4>
            {t("Gastos")} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">{t("Fecha")}</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaGasto}
                required
                onChange={(e) => {
                  setFechaGasto(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                // bsSize="sm"
                type="select"
                required
                value={selectedProveedor}
                onChange={(e) => setSelectedProveedor(e.target.value)}
              >
                <option value="0">{t("Selecciona")}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label className="mr-sm-2">{t("Cliente")}</Label>
              <Input
                // bsSize="sm"
                type="select"
                required
                value={selectedClienteGasto}
                disabled
              >
                <option value="0">{t("Selecciona")}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">{t("Concepto")}</Label>
              <Input
                // bsSize="sm"
                type="select"
                required
                value={selectedConcepto}
                onChange={(e) => setSelectedConcepto(e.target.value)}
              >
                <option value="0">{t("Selecciona")}</option>
                {conceptosGastos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Descripcion")}
              </Label>
              <Input
                type="text"
                placeholder="Descripcion"
                value={descripcion}
                required
                onChange={(e) => {
                  setDescripcion(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">{t("Moneda")}</Label>
              <Input
                // bsSize="sm"
                type="select"
                required
                value={moneda}
                onChange={(e) => {
                  setMoneda(e.target.value);
                  setTotalUSD(0);
                  setTotal(0);
                  setTipoCambio(1);
                }}
              >
                <option value="MXN">{t("MXN")}</option>
                <option value="USD">{t("USD")}</option>
              </Input>
            </Col>
          </Row>
          {moneda === "USD" ? (
            <Row>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  {t("Total USD")}
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="TotalUSD"
                  value={totalUSD}
                  required
                  onChange={(e) => calcula(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Tipo de Cambio
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="TipoCambio"
                  value={tipoCambio}
                  required
                  onChange={(e) => calculaTipoCambio(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  {t("Total MXN")}
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={total}
                  disabled
                  // onChange={(e) => calculaMXN(e.target.value)}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  {t("Total MXN")}
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={total}
                  onChange={(e) => {
                    setTotal(e.target.value);
                    setTotalUSD(e.target.value / tipoCambio);
                  }}
                />
              </Col>
            </Row>
          )}
          <br />
          {validaBoton ? (
            <Button color="success" onClick={() => saveGasto()}>
              Guardar
            </Button>
          ) : (
            <Button color="success" disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalCargos} toggle={toggleCargos}>
        <ModalHeader toggle={toggleCargos}>
          <h4>
            {t("Cargos")} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">{t("Fecha")}</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaGasto}
                required
                onChange={(e) => {
                  setFechaGasto(e.target.value);
                }}
              />
            </Col>

            <Col md={6}>
              <Label className="mr-sm-2">{t("Cliente")}</Label>
              <Input
                // bsSize="sm"
                type="select"
                required
                value={selectedClienteGasto}
                disabled
              >
                <option value="0">{t("Selecciona")}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">{t("Concepto")}</Label>
              <Input
                // bsSize="sm"
                type="select"
                required
                value={selectedConcepto}
                onChange={(e) => setSelectedConcepto(e.target.value)}
              >
                <option value="0">{t("Selecciona")}</option>
                {conceptosGastos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Descripcion")}
              </Label>
              <Input
                type="text"
                placeholder="Descripcion"
                value={descripcion}
                required
                onChange={(e) => {
                  setDescripcion(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">{t("Moneda")}</Label>
              <Input
                // bsSize="sm"
                type="select"
                required
                value={moneda}
                onChange={(e) => {
                  setMoneda(e.target.value);
                  setTotalUSD(0);
                  setTotal(0);
                  setTipoCambio(1);
                }}
              >
                <option value="MXN">{t("MXN")}</option>
                <option value="USD">{t("USD")}</option>
              </Input>
            </Col>
          </Row>
          {moneda === "USD" ? (
            <Row>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  {t("Total USD")}
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="TotalUSD"
                  value={totalUSD}
                  required
                  onChange={(e) => calcula(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Tipo de Cambio
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="TipoCambio"
                  value={tipoCambio}
                  required
                  onChange={(e) => calculaTipoCambio(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  {t("Total MXN")}
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={total}
                  disabled
                  // onChange={(e) => calculaMXN(e.target.value)}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  {t("Total MXN")}
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={total}
                  onChange={(e) => {
                    setTotal(e.target.value);
                    setTotalUSD(e.target.value / tipoCambio);
                  }}
                />
              </Col>
            </Row>
          )}
          <br />
          {validaBoton ? (
            <Button color="success" onClick={() => saveCargo()}>
              Guardar
            </Button>
          ) : (
            <Button color="success" disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalETA} toggle={toggleETA}>
        <ModalHeader toggle={toggleETA}>
          <h4>{t("Actualizar ETAs")}</h4>
        </ModalHeader>
        <ModalBody>
          <EtaUpdate />
        </ModalBody>
      </Modal>

      <Modal
        size="sm"
        isOpen={modalSubirFotoPacking}
        toggle={toggleSubirFotoPacking}
      >
        <ModalHeader toggle={toggleSubirFotoPacking}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Selecciona los Archivos</Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Button size="sm" color="success" onClick={guardaFotosPacking}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoBL} toggle={toggleSubirFotoBL}>
        <ModalHeader toggle={toggleSubirFotoBL}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Selecciona los Archivos</Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Button size="sm" color="success" onClick={guardaFotosBL}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal
        size="sm"
        isOpen={modalSubirFotoInvoice}
        toggle={toggleSubirFotoInvoice}
      >
        <ModalHeader toggle={toggleSubirFotoInvoice}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Selecciona los Archivos</Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Button size="sm" color="success" onClick={guardaFotosInvoice}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal
        size="sm"
        isOpen={modalSubirFotoValidacion}
        toggle={toggleSubirFotoValidacion}
      >
        <ModalHeader toggle={toggleSubirFotoValidacion}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Selecciona los Archivos</Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Button size="sm" color="success" onClick={guardaFotosValidacion}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal
        size="sm"
        isOpen={modalSubirFotoGarantia}
        toggle={toggleSubirFotoGarantia}
      >
        <ModalHeader toggle={toggleSubirFotoGarantia}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Selecciona los Archivos</Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Button size="sm" color="success" onClick={guardaFotosGarantia}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal
        size="sm"
        isOpen={modalSubirFotoTransporte}
        toggle={toggleSubirFotoTransporte}
      >
        <ModalHeader toggle={toggleSubirFotoTransporte}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Selecciona los Archivos</Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Button size="sm" color="success" onClick={guardaFotosTransporte}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalFotoPacking} toggle={toggleFotoPacking}>
        <ModalHeader toggle={toggleFotoPacking}>
          <h4>Packing List</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo.length > 0 ? (
              photo.map((item) => (
                <div
                  key={item.id}
                  style={{ textAlign: "center", marginBottom: "20px" }}
                >
                  {item.format === "pdf" ? (
                    <embed
                      src={item.secure_url}
                      type="application/pdf"
                      width="500"
                      height="600"
                    />
                  ) : item.format === "xls" ||
                    item.format === "xlsx" ||
                    item.format === "xlsm" ? (
                    <a href={item.secure_url} download>
                      <Button color="primary">
                        Descargar {item.original_filename}. {item.format}
                      </Button>
                    </a>
                  ) : (
                    <img
                      src={item.secure_url}
                      alt="Uploaded Image"
                      width="250"
                      height="auto"
                    />
                  )}
                  <div>
                    <Button
                      color="danger"
                      onClick={() => borrarFoto(item.asset_id)}
                      style={{ marginTop: "10px" }}
                    >
                      Eliminar
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalFotoBL} toggle={toggleFotoBL}>
        <ModalHeader toggle={toggleFotoBL}>
          <h4>BL</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo.length > 0 ? (
              photo.map((item) => (
                <div
                  key={item.id}
                  style={{ textAlign: "center", marginBottom: "20px" }}
                >
                  {item.format === "pdf" ? (
                    <embed
                      src={item.secure_url}
                      type="application/pdf"
                      width="500"
                      height="600"
                    />
                  ) : item.format === "xls" ||
                    item.format === "xlsx" ||
                    item.format === "xlsm" ? (
                    <a href={item.secure_url} download>
                      <Button color="primary">
                        Descargar {item.original_filename}. {item.format}
                      </Button>
                    </a>
                  ) : (
                    <img
                      src={item.secure_url}
                      alt="Uploaded Image"
                      width="250"
                      height="auto"
                    />
                  )}
                  <div>
                    <Button
                      color="danger"
                      onClick={() => borrarFoto(item.asset_id)}
                      style={{ marginTop: "10px" }}
                    >
                      Eliminar
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalFotoInvoice} toggle={toggleFotoInvoice}>
        <ModalHeader toggle={toggleFotoInvoice}>
          <h4>Invoice</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo.length > 0 ? (
              photo.map((item) => (
                <div
                  key={item.id}
                  style={{ textAlign: "center", marginBottom: "20px" }}
                >
                  {item.format === "pdf" ? (
                    <embed
                      src={item.secure_url}
                      type="application/pdf"
                      width="500"
                      height="600"
                    />
                  ) : item.format === "xls" ||
                    item.format === "xlsx" ||
                    item.format === "xlsm" ? (
                    <a href={item.secure_url} download>
                      <Button color="primary">
                        Descargar {item.original_filename}. {item.format}
                      </Button>
                    </a>
                  ) : (
                    <img
                      src={item.secure_url}
                      alt="Uploaded Image"
                      width="250"
                      height="auto"
                    />
                  )}
                  <div>
                    <Button
                      color="danger"
                      onClick={() => borrarFoto(item.asset_id)}
                      style={{ marginTop: "10px" }}
                    >
                      Eliminar
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalFotoValidacion}
        toggle={toggleFotoValidacion}
      >
        <ModalHeader toggle={toggleFotoValidacion}>
          <h4>Validacion</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo.length > 0 ? (
              photo.map((item) => (
                <div
                  key={item.id}
                  style={{ textAlign: "center", marginBottom: "20px" }}
                >
                  {item.format === "pdf" ? (
                    <embed
                      src={item.secure_url}
                      type="application/pdf"
                      width="500"
                      height="600"
                    />
                  ) : item.format === "xls" ||
                    item.format === "xlsx" ||
                    item.format === "xlsm" ? (
                    <a href={item.secure_url} download>
                      <Button color="primary">
                        Descargar {item.original_filename}. {item.format}
                      </Button>
                    </a>
                  ) : (
                    <img
                      src={item.secure_url}
                      alt="Uploaded Image"
                      width="250"
                      height="auto"
                    />
                  )}
                  <div>
                    <Button
                      color="danger"
                      onClick={() => borrarFoto(item.asset_id)}
                      style={{ marginTop: "10px" }}
                    >
                      Eliminar
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalFotoGarantia} toggle={toggleFotoGarantia}>
        <ModalHeader toggle={toggleFotoGarantia}>
          <h4>Garantia</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo.length > 0 ? (
              photo.map((item) => (
                <div
                  key={item.id}
                  style={{ textAlign: "center", marginBottom: "20px" }}
                >
                  {item.format === "pdf" ? (
                    <embed
                      src={item.secure_url}
                      type="application/pdf"
                      width="500"
                      height="600"
                    />
                  ) : item.format === "xls" ||
                    item.format === "xlsx" ||
                    item.format === "xlsm" ? (
                    <a href={item.secure_url} download>
                      <Button color="primary">
                        Descargar {item.original_filename}. {item.format}
                      </Button>
                    </a>
                  ) : (
                    <img
                      src={item.secure_url}
                      alt="Uploaded Image"
                      width="250"
                      height="auto"
                    />
                  )}
                  <div>
                    <Button
                      color="danger"
                      onClick={() => borrarFoto(item.asset_id)}
                      style={{ marginTop: "10px" }}
                    >
                      Eliminar
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalFotoTransporte}
        toggle={toggleFotoTransporte}
      >
        <ModalHeader toggle={toggleFotoTransporte}>
          <h4>Transporte</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo.length > 0 ? (
              photo.map((item) => (
                <div
                  key={item.id}
                  style={{ textAlign: "center", marginBottom: "20px" }}
                >
                  {item.format === "pdf" ? (
                    <embed
                      src={item.secure_url}
                      type="application/pdf"
                      width="500"
                      height="600"
                    />
                  ) : item.format === "xls" ||
                    item.format === "xlsx" ||
                    item.format === "xlsm" ? (
                    <a href={item.secure_url} download>
                      <Button color="primary">
                        Descargar {item.original_filename}. {item.format}
                      </Button>
                    </a>
                  ) : (
                    <img
                      src={item.secure_url}
                      alt="Uploaded Image"
                      width="250"
                      height="auto"
                    />
                  )}
                  <div>
                    <Button
                      color="danger"
                      onClick={() => borrarFoto(item.asset_id)}
                      style={{ marginTop: "10px" }}
                    >
                      Eliminar
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalFotos} toggle={toggleFotos}>
        <ModalHeader toggle={toggleFotos}>
          <h4>Archivos</h4>
        </ModalHeader>
        <ModalBody>
          <Table>
            <thead>
              <tr>
                <th>Titulo</th>
                <th>Archivos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Packing</td>
                <td>
                  <>
                    {packing == "Si" ? (
                      <>
                        {/* {packing} */}
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFotoPacking(idContenedor)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    ) : (
                      <>
                        {/* {a.packing} */}
                        <Button color="info" id="Editar" size="sm" disabled>
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    )}
                    {user.contenedoresCreate ? (
                      <Button
                        color="success"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setIdContenedor(idContenedor);
                          // setIdControlCalidad(idControlCalidad)
                          toggleSubirFotoPacking();
                        }}
                      >
                        <i class="fas fa-upload"></i>
                      </Button>
                    ) : (
                      <Button color="success" id="Editar" size="sm" disabled>
                        <i class="fas fa-upload"></i>
                      </Button>
                    )}
                  </>
                </td>
              </tr>
              <tr>
                <td>BL</td>
                <td>
                  <>
                    {blArchivo == "Si" ? (
                      <>
                        {/* {bl} */}
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFotoBL(idContenedor)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    ) : (
                      <>
                        {/* {bl} */}
                        <Button color="info" id="Editar" size="sm" disabled>
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    )}
                    {user.contenedoresCreate ? (
                      <Button
                        color="success"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setIdContenedor(idContenedor);
                          // setIdControlCalidad(idControlCalidad)
                          toggleSubirFotoBL();
                        }}
                      >
                        <i class="fas fa-upload"></i>
                      </Button>
                    ) : (
                      <Button color="success" id="Editar" size="sm" disabled>
                        <i class="fas fa-upload"></i>
                      </Button>
                    )}
                  </>
                </td>
              </tr>
              <tr>
                <td>Invoice</td>
                <td>
                  <>
                    {invoice == "Si" ? (
                      <>
                        {/* {invoice} */}
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFotoInvoice(idContenedor)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    ) : (
                      <>
                        {/* {invoice} */}
                        <Button color="info" id="Editar" size="sm" disabled>
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    )}
                    {user.contenedoresCreate ? (
                      <Button
                        color="success"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setIdContenedor(idContenedor);
                          // setIdControlCalidad(a.idControlCalidad)
                          toggleSubirFotoInvoice();
                        }}
                      >
                        <i class="fas fa-upload"></i>
                      </Button>
                    ) : (
                      <Button color="success" id="Editar" size="sm" disabled>
                        <i class="fas fa-upload"></i>
                      </Button>
                    )}
                  </>
                </td>
              </tr>
              <tr>
                <td>Validacion</td>
                <td>
                  <>
                    {validacion == "Si" ? (
                      <>
                        {/* {validacion} */}
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFotoValidacion(idContenedor)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    ) : (
                      <>
                        {/* {validacion} */}
                        <Button color="info" id="Editar" size="sm" disabled>
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    )}
                    {user.contenedoresCreate ? (
                      <Button
                        color="success"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setIdContenedor(idContenedor);
                          // setIdControlCalidad(a.idControlCalidad)
                          toggleSubirFotoValidacion();
                        }}
                      >
                        <i class="fas fa-upload"></i>
                      </Button>
                    ) : (
                      <Button color="success" id="Editar" size="sm" disabled>
                        <i class="fas fa-upload"></i>
                      </Button>
                    )}
                  </>
                </td>
              </tr>
              <tr>
                <td>Garantia</td>
                <td>
                  <>
                    {garantia == "Si" ? (
                      <>
                        {/* {garantia} */}
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFotoGarantia(idContenedor)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    ) : (
                      <>
                        {/* {garantia} */}
                        <Button color="info" id="Editar" size="sm" disabled>
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    )}
                    {user.contenedoresCreate ? (
                      <Button
                        color="success"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setIdContenedor(idContenedor);
                          // setIdControlCalidad(a.idControlCalidad)
                          toggleSubirFotoGarantia();
                        }}
                      >
                        <i class="fas fa-upload"></i>
                      </Button>
                    ) : (
                      <Button color="success" id="Editar" size="sm" disabled>
                        <i class="fas fa-upload"></i>
                      </Button>
                    )}
                  </>
                </td>
              </tr>
              <tr>
                <td>Transporte</td>
                <td>
                  <>
                    {transporte == "Si" ? (
                      <>
                        {/* {transporte} */}
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFotoTransporte(idContenedor)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    ) : (
                      <>
                        {/* {transporte} */}
                        <Button color="info" id="Editar" size="sm" disabled>
                          <i class="fas fa-camera"></i>
                        </Button>
                      </>
                    )}
                    {user.contenedoresCreate ? (
                      <Button
                        color="success"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setIdContenedor(idContenedor);
                          // setIdControlCalidad(a.idControlCalidad)
                          toggleSubirFotoTransporte();
                        }}
                      >
                        <i class="fas fa-upload"></i>
                      </Button>
                    ) : (
                      <Button color="success" id="Editar" size="sm" disabled>
                        <i class="fas fa-upload"></i>
                      </Button>
                    )}
                  </>
                </td>
              </tr>
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalArchivo} toggle={toggleArchivo}>
        <ModalHeader toggle={toggleArchivo}>
          <h4>{t("Subir Archivo")}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={10}>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>

            <Col md={2}>
              <Badge
                color="info"
                className="w-100 text-center"
                style={{
                  fontSize: "1rem", // más grande el texto
                  padding: "1rem", // más espacio vertical y horizontal
                  minHeight: "3rem", // fuerza un alto mínimo
                  display: "flex", // centra vertical y horizontal
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {totalContenedores} Contenedores
              </Badge>
            </Col>
          </Row>
          <br />

          <Table bordered striped>
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Referencia</th>
                <th>Referencia Cliente</th>
                <th>Contenedor</th>
                <th>ETA</th>
                <th>Importador</th>
                <th>Apoyo</th>
                <th>Articulo</th>
                <th>Valor Factura</th>
                <th>Pedimento</th>
                <th>Modalidad</th>
                <th>Puerto</th>
                <th>Direccion Entrega</th>
              </tr>
            </thead>
            <tbody>
              {inputFieldsContenedores
                .filter((e) => e.referencia != "")
                .map((a) => (
                  <tr key={a.id}>
                    <td>{a.cliente}</td>
                    <td>{a.referencia}</td>
                    <td>{a.referenciaCliente}</td>
                    <td>{a.contenedor}</td>
                    <td>{a.eta}</td>
                    <td>{a.importador}</td>
                    <td>{a.apoyo}</td>
                    <td>{a.articulo}</td>
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.valorFactura)}
                    </td>
                    <td>{a.pedimento}</td>
                    <td>{a.modalidad}</td>
                    <td>{a.puerto}</td>
                    <td>{a.direccionEntrega}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <br />
          <Row>
            <Col md={2}>
          {validaBoton ? (
            <Button color="success" onClick={() => saveContenedoresArchivo()}>
              Guardar
            </Button>
          ) : (
            <Button color="success" disabled>
              Guardar
            </Button>
          )}
          </Col>
          <Col md={2}>
              <Badge
                color="info"
                className="w-100 text-center"
                style={{
                  fontSize: "1rem", // más grande el texto
                  padding: "1rem", // más espacio vertical y horizontal
                  minHeight: "3rem", // fuerza un alto mínimo
                  display: "flex", // centra vertical y horizontal
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {totalContenedores} Contenedores
              </Badge>
            </Col>
            </Row>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoContenedores;
